var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / container (no photo)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live-DAC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private-car-Tailgating-Copy-3",
    transform: "translate(-1529.000000, -717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(80.000000, 603.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-container-(no-photo)",
    transform: "translate(1449.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.8,
    fill: "#D8D8D8",
    x: 0.4,
    y: 0.4,
    width: 31.2,
    height: 31.2,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph/container",
    transform: "translate(2.400000, 8.800000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/container"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.99673469,2.32989474 L3.99673469,10.6891228",
    id: "Line-3",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59869388,0.817192982 L1.59869388,12.2161404",
    id: "Line-3-Copy-7",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.579102,0.817192982 L25.579102,12.2161404",
    id: "Line-3-Copy-8",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19412245,2.32989474 L7.19412245,10.6891228",
    id: "Line-3-Copy",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3915102,2.32989474 L10.3915102,10.6891228",
    id: "Line-3-Copy-2",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.588898,2.32989474 L13.588898,10.6891228",
    id: "Line-3-Copy-3",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7862857,2.32989474 L16.7862857,10.6891228",
    id: "Line-3-Copy-4",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1810612,2.32989474 L23.1810612,10.6891228",
    id: "Line-3-Copy-5",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9836735,2.32989474 L19.9836735,10.6891228",
    id: "Line-3-Copy-6",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.03619048,
    x: 0.917768707,
    y: 0.518095238,
    width: 25.3422585,
    height: 11.9434586
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.55271368e-15,12.9796491 L27.1777959,12.9796491",
    id: "Line-2",
    strokeWidth: 1.03619048,
    strokeLinecap: "square"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerLog);
export default __webpack_public_path__ + "static/media/container_log.3339021f8a854e348928ccdb11f7b894.svg";
export { ForwardRef as ReactComponent };